import { z } from 'zod';
import { ExtendedReceiverCompanySchema } from '../profile/ProfileFormData';

export const ReceiverRegisterSchema = ExtendedReceiverCompanySchema.extend({
  firstname: z.string(),
  lastname: z.string(),
  email: z
    .string({
      required_error: "L'email est requis",
      invalid_type_error: 'Email incorrect',
    })
    .email(),
  password: z
    .string({
      required_error: 'Le mot de passe est requis',
    })
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
});

export type ReceiverRegisterFormData = z.infer<typeof ReceiverRegisterSchema>;
